//@ts-nocheck
import React from 'react';

import Form from '@atlaskit/form';

import SiteSelectorFormFooter from './site-selector-form-footer';
import SiteSelectorRadioGroup from './site-selector-radio-group';

export type SiteSelectorFormProps = {
	readonly sites: string[];

	readonly onNewSiteSelected: () => void;
	readonly onSiteSelected: (site: string) => void;
	readonly onSiteChanged: () => void;
	readonly onSwitchAccountClick: () => void;
	readonly onCancelClick: () => void;
	readonly fullScreenView?: boolean;
};

const SiteSelectorForm = ({
	sites,
	onNewSiteSelected,
	onSiteSelected,
	onSwitchAccountClick,
	onCancelClick,
	onSiteChanged,
	fullScreenView,
}: SiteSelectorFormProps) => {
	const handleFormSubmit = (data: FormData) => {
		if (!data.site || data.site === '') {
			onNewSiteSelected();
		} else {
			onSiteSelected(data.site);
		}
	};

	return (
		<Form onSubmit={handleFormSubmit}>
			{({ formProps, submitting }) => (
				<form {...formProps} name="site-selector">
					<SiteSelectorRadioGroup sites={sites} onSiteChanged={onSiteChanged} />
					<SiteSelectorFormFooter
						canSubmit={!submitting}
						onSwitchAccountClick={onSwitchAccountClick}
						onCancelClick={onCancelClick}
						fullScreenView={fullScreenView}
					/>
				</form>
			)}
		</Form>
	);
};

export type FormData = {
	readonly site: string;
};

export default SiteSelectorForm;
